export function isIntercomEnabledForSession(
	clientId: number,
	forcedValue?: boolean,
): boolean {
	return forcedValue ?? !clientIdBlackList.includes(clientId)
}

const clientIdBlackList = [
	234 /* Client ID for: Danske Bank A/S, Danmark, Sverige Filial */,
]
